import angular from 'angular';
import '../core.module';

export const GENERIC_ERROR_MESSAGE = 'Não foi possível completar a solicitação. Tente novamente.';
export const FORBIDDEN_MESSAGE =
  'Seu perfil não tem permissão para esta ação. Fale com um administrador.';
export const REPEATED_ERROR_WINDOW_MS = 3000;

export function errorMessageFor(rejection) {
  return rejection && rejection.status === 403 ? FORBIDDEN_MESSAGE : GENERIC_ERROR_MESSAGE;
}

function errorHandlerInterceptorFactory($q, $injector) {
  const lastShown = {};
  return {
    responseError(rejection) {
      const NotificationService = $injector.get('NotificationService');
      if (rejection.status === 401) {
        $injector.get('SessionService').clearSession();
        $injector.get('$state').go('auth.login');
      } else if (!(rejection.config && rejection.config.silentErrors)) {
        const message = errorMessageFor(rejection);
        const now = Date.now();
        if (!lastShown[message] || now - lastShown[message] > REPEATED_ERROR_WINDOW_MS) {
          lastShown[message] = now;
          NotificationService.error(message);
        }
      }
      return $q.reject(rejection);
    }
  };
}

errorHandlerInterceptorFactory.$inject = ['$q', '$injector'];

function configureInterceptor($httpProvider) {
  $httpProvider.interceptors.push('ErrorHandlerInterceptor');
}

configureInterceptor.$inject = ['$httpProvider'];

angular
  .module('app.core')
  .factory('ErrorHandlerInterceptor', errorHandlerInterceptorFactory)
  .config(configureInterceptor);
